<template>
    <div>
        <!-- [fix-closecase] softLoading: แสดงตารางเดิมแบบจางระหว่างโหลด แทนการทำลายทิ้ง (เปิดใช้เฉพาะหน้า CloseCase) -->
        <v-progress-linear
            v-if="softLoading && casetab == false"
            indeterminate
            color="cyan"
        ></v-progress-linear>
        <div
            v-if="casetab == true || softLoading"
            :style="softLoading && casetab == false ? 'opacity: 0.5; pointer-events: none;' : ''"
        >
            <div class="text-start font-weight-bold caption">
                <v-sheet class="pl-5" color="light-blue darken-3" dark tile>
                    Show {{ data_case.from }} - {{ data_case.to }} of
                    {{ data_case.total }}
                </v-sheet>
            </div>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="grey lighten-2 text-center"></th>
                            <th
                                class="grey lighten-2 text-center"
                                style="width: 50%"
                            >
                                Case Information
                            </th>
                            <th class="grey lighten-2 text-center">Status</th>
                            <th class="grey lighten-2 text-center">Zone CE</th>
                            <th class="grey lighten-2 text-center"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, id) in data_case.data" :key="id">
                            <td>
                                <v-btn
                                    icon
                                    @click="
                                        favCase(item.maincase_id, id, item.fav)
                                    "
                                >
                                    <v-icon
                                        v-if="item.fav"
                                        color="amber darken-3"
                                        >mdi-star</v-icon
                                    >
                                    <v-icon v-else color="grey lighten-1"
                                        >mdi-star-outline</v-icon
                                    >
                                </v-btn>
                            </td>
                            <td class="pa-3" style="width: 50%">
                                <v-chip
                                    small
                                    label
                                    dark
                                    :class="
                                        item.is_quotation != '' &&
                                        item.is_quotation !== null
                                            ? 'deep-purple mr-2'
                                            : item.special_status == 'CRT'
                                            ? 'red accent-4 mr-2'
                                            : 'teal mr-2'
                                    "
                                >
                                    <span class="font-weight-medium">{{
                                        item.project_name
                                    }}</span>
                                </v-chip>

                                <span class="font-weight-bold">
                                    {{ item.case_id + " - " + item.subcase }}
                                </span>

                                <span
                                    v-if="item.wonumber"
                                    class="ml-1 font-weight-bold primary--text"
                                >
                                    {{ item.wonumber }}
                                </span>

                                <span
                                    class="font-weight-light text-lowercase"
                                    >{{ " " + item.case_type }}</span
                                >
                                <v-chip
                                    v-if="
                                        item.location != null &&
                                            item.shelf_type == 'Pending'
                                    "
                                    color="orange accent-4"
                                    text-color="white"
                                    style="margin-left: 10px"
                                    small
                                >
                                    <label
                                        >Location : {{ item.location }}</label
                                    >
                                </v-chip>
                                <v-chip
                                    v-if="
                                        item.location != null &&
                                            item.shelf_type == 'Complete'
                                    "
                                    color="green accent-4"
                                    text-color="white"
                                    style="margin-left: 10px"
                                    small
                                >
                                    <label
                                        >Location : {{ item.location }}</label
                                    >
                                </v-chip>
                                <br />
                                <span
                                    class="overline font-weight-light text-lowercase"
                                >
                                    owner : {{ item.created_name }}
                                    {{ item.created_date }}

                                    <v-btn
                                        v-if="item.ageing"
                                        class="ma-2"
                                        fab
                                        dark
                                        x-small
                                        elevation="0"
                                        style="width: 25px; height: 20px"
                                        :color="
                                            item.ageing <= 3
                                                ? 'green '
                                                : item.ageing <= 7
                                                ? 'amber '
                                                : 'red '
                                        "
                                    >
                                        {{ item.ageing }}
                                    </v-btn>
                                </span>
                                <div v-if="item.site_name">
                                    <span v-if="item.site_name.length < 150">{{
                                        item.site_name
                                    }}</span>
                                    <span v-else>
                                        {{
                                            item.site_name.substring(0, 150) +
                                                "..."
                                        }}
                                    </span>
                                </div>

                                <div
                                    v-if="item.case_title"
                                    class="font-weight-medium"
                                >
                                    <span>{{ item.case_title }}</span>
                                </div>
                                <div
                                    v-if="item.product_serial"
                                    class="font-weight-medium"
                                >
                                    <span
                                        >{{ item.product_serial }} :
                                        {{
                                            item.product_description
                                                ? item.product_description
                                                : item.product_no
                                        }}
                                    </span>
                                </div>
                                <!-- <div>
                                <span
                                    class="overline font-weight-light text-lowercase"
                                >
                                    last modified :
                                    {{ item.updated_date }}
                                </span>
              </div>-->
                                <div
                                    class="overline font-weight text-uppercase"
                                >
                                    <span
                                        v-for="(part, index_part) in item.parts"
                                        :key="index_part"
                                        :class="
                                            part.ponumber_status == 'Closed'
                                                ? 'green--text darken-4'
                                                : 'red--text darken-3'
                                        "
                                    >
                                        <v-tooltip right>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <label v-bind="attrs" v-on="on">
                                                    # ({{ part.subcase }})
                                                    {{
                                                        part.ponumber !== "null"
                                                            ? part.ponumber
                                                            : ""
                                                    }}

                                                    {{ part.part_name }} -
                                                    {{
                                                        part.ce_status
                                                            ? part.ce_status
                                                            : part.ship_date
                                                            ? part.ship_date_x
                                                            : part.status
                                                    }}
                                                </label>
                                            </template>
                                            <span
                                                v-if="part.required_uefi == 'Y'"
                                                >{{ part.part_description }} (
                                                UEFI )</span
                                            >
                                            <span v-else
                                                >{{ part.part_description }}
                                            </span>
                                        </v-tooltip>
                                        <br />
                                    </span>
                                </div>
                            </td>
                            <td>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            :color="item.main_status_color"
                                            fab
                                            dark
                                            v-on="on"
                                            x-small
                                            elevation="0"
                                        >
                                            <v-icon small>{{
                                                item.main_status_icon
                                            }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ item.main_status_name }}</span>
                                </v-tooltip>
                                <span class="ml-2 font-weight-medium">{{
                                    item.sub_status_name
                                }}</span>
                                <p
                                    v-if="
                                        item.project_name == 'CDAX' ||
                                            item.project_name == 'S-Print'
                                    "
                                    :class="
                                        item.status_name == 'Closed'
                                            ? 'mt-2 font-weight-medium red--text'
                                            : 'mt-2 font-weight-medium'
                                    "
                                >
                                    CDAX : {{ item.status_name }}
                                </p>
                                <p
                                    v-if="condition.status == 'CloseCase'"
                                    class="mt-2 font-weight-medium"
                                >
                                    Booking : {{ item.book_name }}
                                </p>
                            </td>
                            <td class="text-center">
                                {{ item.branch_name }}
                                <span v-if="item.engineer">
                                    <br />
                                    <strong>{{ item.engineer }}</strong>
                                </span>

                                <span
                                    v-if="
                                        item.schedule_date || item.onsite_date
                                    "
                                >
                                    <br />
                                    {{
                                        item.schedule_date
                                            ? item.schedule_date
                                            : item.onsite_date
                                            ? item.onsite_date
                                            : ""
                                    }}
                                </span>

                                <span
                                    class="overline font-weight-light text-uppercase"
                                    v-if="item.solution"
                                >
                                    <br />
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" small
                                                >mdi-comment-text-multiple-outline</v-icon
                                            >
                                        </template>
                                        <span>{{ item.solution }}</span>
                                    </v-tooltip>
                                </span>
                                <br />
                                <span v-if="item.rate_ismart == 'Y'">
                                    <v-chip
                                        small
                                        class="white--text"
                                        color="red"
                                        >EEG</v-chip
                                    >
                                </span>
                            </td>
                            <td>
                                <v-tooltip
                                    v-if="
                                        condition.status == 'CloseCase' &&
                                            item.book_by !== null &&
                                            item.main_status_name != 'Closed'
                                    "
                                    top
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            color="success"
                                            fab
                                            small
                                            v-on="on"
                                            @click="
                                                $emit(
                                                    'return-click',
                                                    item.maincase_id
                                                )
                                            "
                                        >
                                            <v-icon small>mdi-reply</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Return</span>
                                </v-tooltip>

                                <v-tooltip
                                    v-if="
                                        condition.status == 'CloseCase' &&
                                            item.book_by === null &&
                                            condition.is_skip === false &&
                                            closecasecondition !==
                                                'Waiting ZQTM'
                                    "
                                    top
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            color="success"
                                            fab
                                            small
                                            v-on="on"
                                            @click="
                                                $emit(
                                                    'booking-click',
                                                    item.maincase_id
                                                )
                                            "
                                        >
                                            <v-icon small>mdi-cart</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Booking</span>
                                </v-tooltip>
                                <v-tooltip
                                    top
                                    v-if="closecasecondition === 'Waiting ZQTM'"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            color="#f249e1"
                                            fab
                                            small
                                            v-on="on"
                                            @click="
                                                alertgotowaitingclose(
                                                    item.maincase_id
                                                )
                                            "
                                        >
                                            <v-icon color="white" small
                                                >mdi-check</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>ZQTM Complete</span>
                                </v-tooltip>
                                <v-tooltip
                                    v-if="
                                        condition.status == 'CloseCase' &&
                                            (booking_by == item.book_name ||
                                                item.book_name === null)
                                    "
                                    top
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            color="info"
                                            fab
                                            small
                                            v-on="on"
                                            @click="
                                                $emit(
                                                    'click-me',
                                                    item.maincase_id
                                                )
                                            "
                                        >
                                            <v-icon small>mdi-magnify</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>View Detail</span>
                                </v-tooltip>

                                <v-speed-dial
                                    v-if="
                                        condition.status != 'CloseCase' &&
                                            condition.status != 'OnsiteBench'
                                    "
                                    direction="left"
                                    transition="slide-y-reverse-transition"
                                >
                                    <template v-slot:activator>
                                        <v-btn
                                            elevation="0"
                                            light
                                            color="grey lighten-2"
                                            fab
                                            x-small
                                        >
                                            <v-icon>mdi-dots-vertical</v-icon>
                                        </v-btn>
                                    </template>

                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                color="info"
                                                fab
                                                small
                                                v-on="on"
                                                :to="
                                                    '/Project/ViewCasepending/' +
                                                        (condition.team == ''
                                                            ? item.case_team_name
                                                            : condition.team) +
                                                        '/' +
                                                        item.maincase_id +
                                                        '/' +
                                                        condition.status
                                                "
                                                target="_blank"
                                            >
                                                <v-icon small
                                                    >mdi-magnify</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <span
                                            >View Detail{{
                                                data_pickup.status_name
                                            }}</span
                                        >
                                    </v-tooltip>

                                    <v-tooltip
                                        top
                                        v-if="
                                            item.project_name ==
                                                'Thailand Post (PO)' ||
                                                item.project_name ==
                                                    'Thailand Post (PO) TRACK & TRACE'
                                        "
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                color="success"
                                                fab
                                                small
                                                v-on="on"
                                                :to="
                                                    '/Project/Nonhp/DocNonhp/' +
                                                        item.maincase_id +
                                                        '/' +
                                                        item.subcase_id
                                                "
                                                target="_blank"
                                            >
                                                <v-icon small>mdi-fax</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Print</span>
                                    </v-tooltip>
                                    <v-tooltip
                                        top
                                        v-if="
                                            item.sub_status_name ===
                                                'Back Order'
                                        "
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                color
                                                fab
                                                small
                                                v-on="on"
                                                @click="
                                                    passtoonsite(
                                                        item.maincase_id,
                                                        item.site_province_id,
                                                        item.site_amphur_id,
                                                        item.site_address,
                                                        item.engineer_id,
                                                        item.branch_id,
                                                        item.remark
                                                    )
                                                "
                                            >
                                                <v-icon small
                                                    >mdi-car-estate</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <span>Pass to onsite</span>
                                    </v-tooltip>

                                    <v-tooltip
                                        top
                                        v-if="
                                            item.sub_status_name ==
                                                'Happycall Rejected'
                                        "
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                color="#4c9103"
                                                fab
                                                small
                                                v-on="on"
                                                @click="
                                                    change_status(
                                                        item.maincase_id
                                                    )
                                                "
                                                target="_blank"
                                            >
                                                <v-icon small color="white"
                                                    >mdi-wrench</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <span>Change Status</span>
                                    </v-tooltip>
                                    <v-tooltip
                                        top
                                        v-if="
                                            item.sub_status_name == 'DOA Unit'
                                        "
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                color="#990066"
                                                fab
                                                small
                                                v-on="on"
                                                @click="
                                                    doaunit(
                                                        item.maincase_id,
                                                        item.case_id,
                                                        item.subcase
                                                    )
                                                "
                                                target="_blank"
                                            >
                                                <v-icon small color="white"
                                                    >mdi-alert-plus</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <span>DOA Unit</span>
                                    </v-tooltip>
                                    <v-tooltip
                                        v-if="
                                            item.project_name == 'ODM' ||
                                                team_name == 'ODM'
                                        "
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                color="success"
                                                fab
                                                small
                                                v-on="on"
                                                :to="
                                                    '/Project/PrintODM/' +
                                                        item.maincase_id +
                                                        '/' +
                                                        item.subcase_id
                                                "
                                                target="_blank"
                                            >
                                                <v-icon small>mdi-fax</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Print</span>
                                    </v-tooltip>
                                    <v-tooltip
                                        v-if="
                                            item.main_status_name ==
                                                'Incomplete' &&
                                                item.sub_status_name !=
                                                    'Waiting Quotation' &&
                                                item.sub_status_name !=
                                                    'Pickup Unit' &&
                                                item.sub_status_name !=
                                                    'Pickup Monitor'
                                        "
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                color="success"
                                                fab
                                                small
                                                v-on="on"
                                                @click="
                                                    opennewsub(
                                                        condition.team,
                                                        item.maincase_id
                                                    )
                                                "
                                            >
                                                <v-icon small>mdi-plus</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Open New Sub</span>
                                    </v-tooltip>

                                    <v-tooltip
                                        v-if="
                                            item.sub_status_name ==
                                                'Send to BKK' ||
                                                item.send_status ==
                                                    'svccomplete'
                                        "
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                @click="
                                                    savesendtobkk(
                                                        item.maincase_id
                                                    )
                                                "
                                                color="success"
                                                fab
                                                small
                                                v-on="on"
                                            >
                                                <v-icon small
                                                    >mdi-car-pickup</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <span>Wait Cust.pickup</span>
                                    </v-tooltip>
                                    <v-tooltip
                                        v-if="
                                            item.sub_status_name != 'Closed' &&
                                                team_name == 'BENCH RAMA3' &&
                                                condition.status !=
                                                    'OnsiteBench'
                                        "
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                @click="
                                                    getEngineerBenchRama3(
                                                        item.maincase_id,
                                                        data_case.data[id]
                                                            .engineer_id
                                                    ),
                                                        (search = ''),
                                                        (dialogassign = true),
                                                        getTypeLocaTion(
                                                            data_case.data[id]
                                                                .sub_status_name,
                                                            data_case.data[id]
                                                                .location
                                                        )
                                                "
                                                color="brown"
                                                fab
                                                small
                                                v-on="on"
                                            >
                                                <v-icon small color="white"
                                                    >mdi-account</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <span>{{
                                            item.sub_status_name == "Complete"
                                                ? "Edit Location"
                                                : "Assign"
                                        }}</span>
                                    </v-tooltip>
                                    <v-tooltip
                                        v-if="
                                            item.sub_status_name ==
                                                'Waiting Quotation'
                                        "
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                @click="
                                                    savequotation(
                                                        item.maincase_id,
                                                        'Approved',
                                                        item.subcase_id
                                                    )
                                                "
                                                color="success"
                                                fab
                                                small
                                                v-on="on"
                                            >
                                                <v-icon small
                                                    >mdi-check-bold</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <span>Quotation Approved</span>
                                    </v-tooltip>

                                    <v-tooltip
                                        v-if="
                                            item.sub_status_name ==
                                                'Waiting Quotation'
                                        "
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                @click="
                                                    savequotation(
                                                        item.maincase_id,
                                                        'Rejected',
                                                        item.subcase_id
                                                    )
                                                "
                                                color="red accent-4"
                                                fab
                                                small
                                                v-on="on"
                                            >
                                                <v-icon small color="white"
                                                    >mdi-close-thick</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <span>Quotation Rejected</span>
                                    </v-tooltip>

                                    <v-tooltip
                                        v-if="
                                            item.main_status_name ===
                                                'Waiting Cust. Pickup'
                                        "
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                color="success"
                                                fab
                                                small
                                                v-on="on"
                                                @click="
                                                    change_cus_pickup(
                                                        item.maincase_id
                                                    )
                                                "
                                            >
                                                <v-icon small
                                                    >mdi-calendar-account</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <span>Customer Pickup</span>
                                    </v-tooltip>

                                    <v-tooltip
                                        v-if="
                                            item.sub_status_name ==
                                                'Pickup Unit' ||
                                                item.sub_status_name ==
                                                    'Pickup Monitor'
                                        "
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                color="success"
                                                @click="
                                                    confirmpickup(
                                                        item.maincase_id,
                                                        item.sub_status_name
                                                    )
                                                "
                                                fab
                                                small
                                                v-on="on"
                                                target="_blank"
                                            >
                                                <v-icon small
                                                    >mdi-chevron-up-circle</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <span>Confirm Pickup</span>
                                    </v-tooltip>
                                </v-speed-dial>

                                <v-speed-dial
                                    v-if="condition.status == 'OnsiteBench'"
                                    direction="left"
                                    transition="slide-y-reverse-transition"
                                >
                                    <template v-slot:activator>
                                        <v-btn
                                            elevation="0"
                                            light
                                            color="grey lighten-2"
                                            fab
                                            x-small
                                        >
                                            <v-icon>mdi-dots-vertical</v-icon>
                                        </v-btn>
                                    </template>

                                    <v-tooltip
                                        v-if="condition.status == 'OnsiteBench'"
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                :to="
                                                    '/Project/Bench/Onsite/CloseCase/' +
                                                        item.maincase_id
                                                "
                                                color="danger"
                                                fab
                                                small
                                                v-on="on"
                                            >
                                                <v-icon small>mdi-close</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Close Job</span>
                                    </v-tooltip>

                                    <v-tooltip
                                        v-if="
                                            item.sub_status_name != 'Closed' &&
                                                team_name == 'BENCH RAMA3' &&
                                                condition.status ==
                                                    'OnsiteBench'
                                        "
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                @click="
                                                    getEngineerBenchRama3(
                                                        item.maincase_id,
                                                        data_case.data[id]
                                                            .engineer_id
                                                    ),
                                                        (search = ''),
                                                        (dialogassign = true),
                                                        getTypeLocaTion(
                                                            data_case.data[id]
                                                                .sub_status_name
                                                        )
                                                "
                                                color="brown"
                                                fab
                                                small
                                                v-on="on"
                                            >
                                                <v-icon small color="white"
                                                    >mdi-account</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <span>{{
                                            item.sub_status_name == "Complete"
                                                ? "Edit Location"
                                                : "Assign"
                                        }}</span>
                                    </v-tooltip>
                                </v-speed-dial>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <div class="text-start font-weight-bold caption">
                <v-sheet class="pl-5" color="light-blue darken-3" dark tile>
                    Show {{ data_case.from }} - {{ data_case.to }} of
                    {{ data_case.total }}
                </v-sheet>
            </div>

            <template>
                <v-row justify="center">
                    <v-dialog
                        v-model="dialog"
                        fullscreen
                        hide-overlay
                        transition="dialog-bottom-transition"
                    >
                        <v-card>
                            <v-toolbar dark color="primary">
                                <v-btn icon dark @click="close_pickup()">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <v-toolbar-title>
                                    {{
                                        data_pickup.case_id +
                                            "-" +
                                            data_pickup.subcase
                                    }}
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <v-btn dark text @click="save_pickup()"
                                        >Save</v-btn
                                    >
                                </v-toolbar-items>
                            </v-toolbar>
                            <v-list three-line subheader>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-row>
                                            <v-col cols="12">
                                                <b>Case Title1 :</b>
                                                <span class="fix-color">{{
                                                    data_pickup.case_title
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <b>Ce Update Status :</b>
                                                <span class="fix-color">
                                                    {{
                                                        data_pickup.ce_update_status
                                                    }}
                                                </span>
                                            </v-col>

                                            <v-col cols="12" sm="6">
                                                <ViewCdax
                                                    :caseid="
                                                        data_pickup.case_id
                                                    "
                                                />
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <b>OnsiteDate :</b>
                                                <span class="fix-color">{{
                                                    data_pickup.onsite_date
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <b>Schedule Range :</b>
                                                <span class="fix-color">{{
                                                    data_pickup.schedule_range
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <b>Zone :</b>
                                                <span class="fix-color">{{
                                                    data_pickup.branch_name
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <b>Site Name :</b>
                                                <span class="fix-color">{{
                                                    data_pickup.site_name
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <b>Engineer :</b>
                                                <span class="fix-color">{{
                                                    data_pickup.engineer_name
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <b>Customer Name:</b>
                                                <span class="fix-color">{{
                                                    data_pickup.customer_name
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12">
                                                <b>Customer Tel :</b>
                                                <span class="fix-color">{{
                                                    data_pickup.customer_tal
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-textarea
                                                    outlined
                                                    readonly
                                                    v-model="
                                                        data_pickup.lognote
                                                    "
                                                    label="Lognote..."
                                                ></v-textarea>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-textarea
                                                    outlined
                                                    readonly
                                                    v-model="
                                                        data_pickup.cdax_log
                                                    "
                                                    label="CDAX Log..."
                                                ></v-textarea>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                md="4"
                                                class="mar-t-30"
                                            >
                                                <v-radio-group
                                                    v-model="status_log"
                                                    row
                                                >
                                                    <v-radio
                                                        label="โทรติดต่อลูกค้า"
                                                        value="1"
                                                        @change="
                                                            get_auto_log(1)
                                                        "
                                                    ></v-radio>
                                                    <v-radio
                                                        label="ลูกค้ามารับเครื่องเเล้ว"
                                                        @change="
                                                            get_auto_log(2)
                                                        "
                                                        value="2"
                                                    ></v-radio>
                                                </v-radio-group>
                                                <div v-if="status_log == 1">
                                                    <v-menu
                                                        v-model="datemenu1"
                                                        :close-on-content-click="
                                                            false
                                                        "
                                                        transition="scale-transition"
                                                        offset-y
                                                        max-width="290px"
                                                        min-width="290px"
                                                    >
                                                        <template
                                                            v-slot:activator="{
                                                                on,
                                                            }"
                                                        >
                                                            <v-text-field
                                                                label="วันที่นัดลูกค้ามารับเครื่อง"
                                                                hint="MM/DD/YYYY format"
                                                                v-model="date"
                                                                readonly
                                                                v-on="on"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            :min="date_min"
                                                            @change="
                                                                get_auto_log(1)
                                                            "
                                                            v-model="date"
                                                            no-title
                                                            @input="
                                                                datemenu1 = false
                                                            "
                                                        ></v-date-picker>
                                                    </v-menu>
                                                </div>
                                            </v-col>
                                            <v-col
                                                v-if="status_log != null"
                                                cols="12"
                                                md="4"
                                                class="mar-t-20"
                                            >
                                                <v-textarea
                                                    outlined
                                                    v-model="text_copy"
                                                    @change="logchange"
                                                    label="Auto Log..."
                                                ></v-textarea>

                                                <v-tooltip top>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                        }"
                                                    >
                                                        <v-btn
                                                            style="
                                                                margin-left: -15px;
                                                                margin-top: -80px;
                                                            "
                                                            small
                                                            v-on="on"
                                                            color="blue lighten-1"
                                                            fab
                                                            @click="
                                                                doCopyCase()
                                                            "
                                                        >
                                                            <v-icon
                                                                color="white"
                                                                >mdi-content-copy</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>Copy Log</span>
                                                </v-tooltip>
                                            </v-col>
                                            <v-col
                                                v-if="
                                                    status_log != null &&
                                                        autolog2 != ''
                                                "
                                                cols="12"
                                                md="4"
                                                class="mar-t-20"
                                            >
                                                <v-textarea
                                                    outlined
                                                    v-model="text_copy2"
                                                    @change="logchange2()"
                                                    label="Auto Log2..."
                                                ></v-textarea>

                                                <v-tooltip top>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                        }"
                                                    >
                                                        <v-btn
                                                            style="
                                                                margin-left: -15px;
                                                                margin-top: -80px;
                                                            "
                                                            small
                                                            v-on="on"
                                                            color="blue lighten-1"
                                                            fab
                                                            @click="
                                                                doCopyCase2()
                                                            "
                                                        >
                                                            <v-icon
                                                                color="white"
                                                                >mdi-content-copy</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>Copy Log</span>
                                                </v-tooltip>
                                            </v-col>

                                            <!-- <v-col cols="1" align-self="end"></v-col> -->
                                        </v-row>

                                        <view-engineerformation
                                            :detailcase="detailcase"
                                            :active_tab="active_tab"
                                        />
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-dialog>
                </v-row>
            </template>

            <template>
                <v-row justify="center">
                    <v-form method="post" id="nativeForm" v-model="valid">
                        <v-row justify="center">
                            <v-dialog
                                v-model="dialogchangestatus"
                                fullscreen
                                hide-overlay
                                transition="dialog-bottom-transition"
                            >
                                <v-card>
                                    <v-toolbar dark color="primary">
                                        <v-btn
                                            icon
                                            dark
                                            @click="close_changestatus()"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                        <v-toolbar-title>
                                            {{
                                                data_pickup.case_id +
                                                    "-" +
                                                    data_pickup.subcase
                                            }}
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-toolbar-items>
                                            <v-btn
                                                :disabled="!valid"
                                                dark
                                                text
                                                @click="save_changestatus()"
                                                >Save</v-btn
                                            >
                                        </v-toolbar-items>
                                    </v-toolbar>
                                    <v-list three-line subheader>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <b>Case Title :</b>
                                                        <span class="fix-color">
                                                            {{
                                                                data_pickup.case_title
                                                            }}
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <b
                                                            >Engineer Update
                                                            Status :</b
                                                        >
                                                        <span class="fix-color">
                                                            {{
                                                                data_pickup.ce_update_status
                                                            }}
                                                        </span>
                                                    </v-col>

                                                    <v-col cols="12" sm="6">
                                                        <view-cdax
                                                            :caseid="
                                                                data_pickup.case_id
                                                            "
                                                        />
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <b>Onsite Date :</b>
                                                        <span
                                                            class="fix-color"
                                                            >{{
                                                                data_pickup.onsite_date
                                                            }}</span
                                                        >
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <b>Schedule Range :</b>
                                                        <span
                                                            class="fix-color"
                                                            >{{
                                                                data_pickup.schedule_range
                                                            }}</span
                                                        >
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <b>Zone :</b>
                                                        <span
                                                            class="fix-color"
                                                            >{{
                                                                data_pickup.branch_name
                                                            }}</span
                                                        >
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <b>Site Name :</b>
                                                        <span class="fix-color">
                                                            {{
                                                                data_pickup.site_name
                                                            }}
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <b>Engineer :</b>
                                                        <span
                                                            class="fix-color"
                                                            >{{
                                                                data_pickup.engineer_name
                                                            }}</span
                                                        >
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <b>Customer Name :</b>
                                                        <span
                                                            class="fix-color"
                                                            >{{
                                                                data_pickup.customer_name
                                                            }}</span
                                                        >
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <b>Customer Tel :</b>
                                                        <span
                                                            class="fix-color"
                                                            >{{
                                                                data_pickup.customer_tal
                                                            }}</span
                                                        >
                                                    </v-col>
                                                    <v-col cols="12" md="6">
                                                        <v-textarea
                                                            outlined
                                                            readonly
                                                            v-model="
                                                                data_pickup.lognote
                                                            "
                                                            label="Lognote..."
                                                        ></v-textarea>
                                                    </v-col>
                                                    <v-col cols="12" md="6">
                                                        <v-textarea
                                                            outlined
                                                            readonly
                                                            v-model="
                                                                data_pickup.cdax_log
                                                            "
                                                            label="CDAX Log..."
                                                        ></v-textarea>
                                                    </v-col>

                                                    <v-col
                                                        v-if="
                                                            status_log != null
                                                        "
                                                        cols="12"
                                                        md="6"
                                                        class="mar-t-20"
                                                    >
                                                        <v-textarea
                                                            outlined
                                                            v-model="text_copy"
                                                            label="Auto Log..."
                                                        ></v-textarea>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        md="12"
                                                        class="mar-t-20"
                                                    >
                                                        <v-btn
                                                            @click="
                                                                buttonstatus =
                                                                    'complete'
                                                            "
                                                            :color="
                                                                buttonstatus ===
                                                                'complete'
                                                                    ? 'green'
                                                                    : 'white'
                                                            "
                                                        >
                                                            <v-icon left
                                                                >mdi-check</v-icon
                                                            >Complete
                                                        </v-btn>
                                                        <v-btn
                                                            v-if="
                                                                data_pickup.status_name !=
                                                                    'Closed'
                                                            "
                                                            @click="
                                                                buttonstatus =
                                                                    'incomplete'
                                                            "
                                                            :color="
                                                                buttonstatus ===
                                                                'incomplete'
                                                                    ? 'red'
                                                                    : 'white'
                                                            "
                                                        >
                                                            <v-icon left
                                                                >mdi-close</v-icon
                                                            >Incomplete
                                                        </v-btn>
                                                        <v-btn
                                                            v-if="
                                                                data_pickup.status_name !=
                                                                    'Closed'
                                                            "
                                                            @click="
                                                                buttonstatus =
                                                                    'zone'
                                                            "
                                                            :color="
                                                                buttonstatus ===
                                                                'zone'
                                                                    ? 'blue'
                                                                    : 'white'
                                                            "
                                                        >
                                                            <v-icon left
                                                                >mdi-home</v-icon
                                                            >ดึงเคสกลับ Zone
                                                            Pending ช่าง
                                                        </v-btn>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        md="12"
                                                        class="mar-t-20"
                                                    >
                                                        <v-btn
                                                            v-if="
                                                                buttonstatus ==
                                                                    'incomplete'
                                                            "
                                                            @click="
                                                                buttonquotation =
                                                                    'Y'
                                                            "
                                                            :color="
                                                                buttonquotation ===
                                                                'Y'
                                                                    ? 'green'
                                                                    : 'white'
                                                            "
                                                        >
                                                            <v-icon left
                                                                >mdi-check</v-icon
                                                            >เสนอราคา
                                                        </v-btn>
                                                        <v-btn
                                                            v-if="
                                                                buttonstatus ==
                                                                    'incomplete'
                                                            "
                                                            @click="
                                                                buttonquotation =
                                                                    'N'
                                                            "
                                                            :color="
                                                                buttonquotation ===
                                                                'N'
                                                                    ? 'red'
                                                                    : 'white'
                                                            "
                                                        >
                                                            <v-icon left
                                                                >mdi-close</v-icon
                                                            >ไม่เสนอราคา
                                                        </v-btn>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        md="12"
                                                        class="mar-t-20"
                                                        style="margin-top: 20px"
                                                    >
                                                        <v-text-field
                                                            label="Reason"
                                                            :rules="reasonR"
                                                            required
                                                            v-model="reason"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="1"
                                                        align-self="end"
                                                    ></v-col>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-card>
                            </v-dialog>
                        </v-row>
                    </v-form>
                </v-row>
            </template>
            <v-form method="post" id="nativeForm" v-model="validdoa">
                <template>
                    <v-row justify="center">
                        <v-dialog
                            v-model="dialogdoa"
                            scrollable
                            max-width="500px"
                        >
                            <v-card>
                                <v-card-title>{{ datacaseID }}</v-card-title>
                                <v-divider></v-divider>
                                <v-card-text style="height: 200px">
                                    <v-row>
                                        <v-col cols="6" sm="3" md="3">
                                            <v-btn
                                                @click="selectbtndoa(1)"
                                                :color="
                                                    btnselect == 1
                                                        ? 'green'
                                                        : ''
                                                "
                                                :style="
                                                    btnselect == 1
                                                        ? 'color:white'
                                                        : 'color:black'
                                                "
                                                >Approve</v-btn
                                            >
                                        </v-col>
                                        <v-col cols="6" sm="3" md="3">
                                            <v-btn
                                                @click="selectbtndoa(2)"
                                                :color="
                                                    btnselect == 2 ? 'red' : ''
                                                "
                                                :style="
                                                    btnselect == 2
                                                        ? 'color:white'
                                                        : 'color:black'
                                                "
                                                >Reject</v-btn
                                            >
                                        </v-col>
                                    </v-row>
                                    <v-row style="margin-top: 25px">
                                        <v-col cols="12" sm="12" md="12">
                                            <v-text-field
                                                label="Remark"
                                                placeholder="ข้อความ"
                                                v-model="remark_status_doa"
                                                :rules="remarkR"
                                                required
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-btn
                                        color="blue darken-1"
                                        text
                                        @click="dialogdoa = false"
                                    >
                                        Close
                                    </v-btn>
                                    <v-btn
                                        color="blue darken-1"
                                        text
                                        :disabled="!validdoa"
                                        @click="savestatusdoa"
                                    >
                                        Save
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>
            </v-form>
            <template>
                <v-row justify="center">
                    <v-dialog
                        v-model="dialogconfirm"
                        scrollable
                        max-width="800px"
                    >
                        <v-card>
                            <v-divider></v-divider>
                            <v-card-text style="height: 300px">
                                <v-row
                                    style="margin-top: 100px"
                                    justify="center"
                                >
                                    <v-radio-group v-model="pick_up.value" row>
                                        <v-radio
                                            label="เปิด sub ใหม่ ส่งเครื่องคืนลูกค้า"
                                            value="sendcustomer"
                                        ></v-radio>
                                        <v-radio
                                            :label="pick_up.status"
                                            :value="pick_up.showvalue"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-row>
                                <v-row justify="center">
                                    <v-col cols="6">
                                        <v-textarea
                                            v-model="pick_up.remark"
                                            label="Remark"
                                            filled
                                            height="30"
                                            outlined
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="blue darken-1"
                                    text
                                    @click="dialogconfirm = false"
                                    >Close</v-btn
                                >
                                <v-btn
                                    color="blue darken-1"
                                    text
                                    @click="save_confirm()"
                                    >Save</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
            </template>

            <template>
                <v-row justify="center">
                    <v-dialog v-model="dialogonsite" width="700">
                        <v-card>
                            <v-card-title
                                class="headline grey lighten-2"
                                primary-title
                            ></v-card-title>
                            <v-card-text>
                                <v-row class="mb-5 mt-5" justify="center">
                                    <h3>
                                        Site Name :
                                        {{ data_onsite.site_address }}
                                    </h3>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-select
                                            :items="svc"
                                            v-model="data_onsite.branch_id"
                                            item-text="branch_name"
                                            item-value="branch_id"
                                            label="Zone"
                                            dense
                                            outlined
                                            menu-props="auto"
                                            hide-details
                                            @change="
                                                getEngineer(
                                                    data_onsite.branch_id
                                                )
                                            "
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-select
                                            :items="engineer"
                                            v-model="data_onsite.engineer"
                                            item-text="emp_name_en"
                                            item-value="emp_id"
                                            label="Engineer"
                                            dense
                                            outlined
                                        ></v-select>
                                    </v-col>
                                    <v-col
                                        v-if="data_onsite.engineer != 'ZONE'"
                                        cols="12"
                                        sm="6"
                                        md="3"
                                    >
                                        <v-menu
                                            v-model="datemenu"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="
                                                        computedDateFormatted
                                                    "
                                                    label="Date Onsite"
                                                    hint="YYYY-MM-DD format"
                                                    readonly
                                                    v-on="on"
                                                    outlined
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                :min="today"
                                                v-model="datenew"
                                                no-title
                                                @input="datemenu = false"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col
                                        v-if="
                                            data_onsite.engineer != 'ZONE' &&
                                                datenew == today
                                        "
                                        cols="12"
                                        sm="6"
                                        md="3"
                                    >
                                        <v-select
                                            :items="schedule"
                                            item-text="schedule_range"
                                            item-value="schedule_id"
                                            v-model="data_onsite.timeonsite"
                                            label="Schedule Time Onsite"
                                            dense
                                            outlined
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="12">
                                        <v-text-field
                                            label="Remark"
                                            v-model="data_onsite.remark"
                                            outlined
                                            placeholder="ข้อความ"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-btn
                                    color="blue darken-1"
                                    text
                                    @click="dialogonsite = false"
                                    >Close</v-btn
                                >
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="primary"
                                    text
                                    @click="saveonsite()"
                                    >Save</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
            </template>
            <v-form method="post" id="nativeForm" v-model="validassign">
                <template>
                    <v-row justify="center">
                        <v-dialog
                            v-model="dialogassign"
                            scrollable
                            max-width="800px"
                        >
                            <v-card>
                                <v-divider></v-divider>
                                <v-card-text style="height: 150px">
                                    <v-row
                                        style="margin-top: 20px"
                                        justify="center"
                                    >
                                        <v-col
                                            v-if="
                                                dataLocationStatus != 'Complete'
                                            "
                                        >
                                            <v-select
                                                class="pr-3"
                                                outlined
                                                clearable
                                                v-model="dataEngineer"
                                                :rules="EngineerR"
                                                required
                                                :items="data_engineerbenchrama3"
                                                item-text="emp_name_en"
                                                item-value="emp_id"
                                            >
                                                <template v-slot:label>
                                                    <v-icon
                                                        small
                                                        class="mb-1"
                                                        style="
                                                            vertical-align: middle;
                                                        "
                                                    >
                                                        mdi-face-recognition
                                                    </v-icon>
                                                    Select Engineer
                                                </template>
                                            </v-select>
                                        </v-col>
                                        <v-col>
                                            <v-autocomplete
                                                v-model="dataLocation"
                                                :items="datatypeLocation.shelf"
                                                :search-input.sync="search"
                                                hint="Maximum of 1 tags"
                                                label="DataLocation"
                                                :rules="LocationR"
                                                required
                                                small-chips
                                                style="color: yellow"
                                                color="blue-grey lighten-2"
                                            >
                                                <!-- <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>
                              No results matching "<strong>{{ search }}</strong
                              >". Press <kbd>enter</kbd> to create a new one
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template> -->
                                            </v-autocomplete>
                                            <!-- <v-autocomplete
                      outlined
                      dense
                      chips
                      small-chips
                      v-model="dataLocation"
                      :items="datatypeLocation.shelf"
                      label="Location"
                      :rules="LocationR"
                      required
                      multiple
                    ></v-autocomplete> -->

                                            <!-- <v-text-field
                      label="Location"
                      v-model="dataLocation"
                      outlined
                      :rules="LocationR"
                      required
                    ></v-text-field> -->
                                        </v-col>
                                    </v-row>
                                </v-card-text>

                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="blue darken-1"
                                        text
                                        @click="dialogassign = false"
                                        >Close</v-btn
                                    >
                                    <v-btn
                                        v-if="dataLocationStatus != 'Complete'"
                                        color="blue darken-1"
                                        @click="saveassignbenchrama3()"
                                        text
                                        :disabled="!validassign"
                                        >Save</v-btn
                                    >

                                    <v-btn
                                        v-else
                                        color="blue darken-1"
                                        @click="saveassignbenchrama3('edit')"
                                        text
                                        :disabled="!validassign"
                                        >Save</v-btn
                                    >
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>
            </v-form>
            <!-- snackbar -->
            <div id="snackbar" class="d-print-none" v-if="text1 != ''">
                <v-snackbar v-model="snackbar" color="success" right>
                    {{ text1 }}
                </v-snackbar>
            </div>
            <div id="snackbar" class="d-print-none" v-else>
                <v-snackbar v-model="snackbar" color="success" right>
                    {{ text }}
                </v-snackbar>
            </div>
        </div>
        <div v-else-if="casetab == false">
            <v-progress-linear indeterminate color="cyan"></v-progress-linear>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import ViewCdax from "../../../components/ViewCdax"
import ViewEngineerInformation from "../components/ViewEngineerInformation"
export default {
    props: ["data_case", "condition", "closecasecondition", "casetab", "text1", "softLoading"],
    computed: {
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),
        computedDateFormatted() {
            this.data_onsite.dateonsite = this.formatDate(this.datenew)
            return this.data_onsite.dateonsite
        },
    },
    mounted() {},
    components: {
        ViewCdax,
        "view-engineerformation": ViewEngineerInformation,
    },

    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        snackbarClose(val) {
            this.$store.commit("snackbarClose", val)
        },
        // saveoptionlocation() {
        //   if (
        //     this.search != "null" &&
        //     this.search != undefined &&
        //     this.search != ""
        //   ) {
        //     this.datatypeLocation.shelf.push(this.search);
        //   }
        // },
        async getTypeLocaTion(status, location) {
            this.dataLocationStatus = status

            this.dataLocation = location
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                const url = `${process.env.VUE_APP_ROOT_API}/api/get-shelf-location`
                this.status_name = ""
                this.mutateIsLoading()

                this.dataLocationStatus == "Complete"
                    ? (this.status_name = "Complete")
                    : (this.status_name = "Pending")

                const { data } = await axios.get(
                    url + "/" + this.status_name,
                    options
                )

                this.datatypeLocation = data
                // if (location != undefined) {
                //   this.datatypeLocation.shelf.push(location);
                // }
                // console.log(data, "ttt");
                this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        },
        async savestatusdoa() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                if (this.btnselect == 1) {
                    status = "Approve"
                } else if (this.btnselect == 2) {
                    status = "Reject"
                }
                var datasave = {
                    status: status,
                    remark: this.remark_status_doa,
                }
                const url = `${process.env.VUE_APP_ROOT_API}/api/doa-unit`

                this.mutateIsLoading()
                const { data } = await axios.post(
                    url + "/" + this.maincase_id_doa,
                    datasave,
                    options
                )
                if (this.btnselect === 2) {
                    this.$swal({
                        title: "Open new sub ?",
                        text:
                            "ถ้ายังไม่เปิดซับใหม่ในตอนนี้ สถานะเคสจะเปลี่ยนเป็น incomplete ",
                        icon: "warning",
                        buttons: true,
                        dangerMode: true,
                    }).then((opensub) => {
                        if (opensub) {
                            this.$router.push({
                                path: `/Project/${this.condition.team}/SubCase/${this.maincase_id_doa}`,
                            })
                        }
                    })
                } else {
                    this.$emit("getCase")
                    this.$emit("getSummary")
                }

                this.mutateIsLoading()
                this.dialogdoa = false
            } catch (error) {
                console.log(error)
            }
        },
        selectbtndoa(select) {
            if (select == 1) {
                this.btnselect = 1
            } else {
                this.btnselect = 2
            }
        },
        async saveassignbenchrama3(savestatus) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                if (savestatus == "edit") {
                    var datasave = {
                        maincase_id: this.dataMaincase,
                        engineer: savestatus,
                        location: this.dataLocation,
                    }
                } else {
                    var datasave = {
                        maincase_id: this.dataMaincase,
                        engineer: this.dataEngineer,
                        location: this.dataLocation,
                    }
                }
                const url = `${process.env.VUE_APP_ROOT_API}/api/save-assigned-bkk`

                this.mutateIsLoading()
                const { data } = await axios.post(url, datasave, options)
                this.$emit("getOwnerTodayCase-click")
                this.$emit("getCase")
                this.$emit("getSummary")
                this.mutateIsLoading()
                this.dialogassign = false
            } catch (error) {
                console.log(error)
            }
        },
        async getEngineerBenchRama3(maincaseid, engineer) {
            this.dataMaincase = maincaseid

            if (engineer == "ZONE") {
                this.dataEngineer = ""
            } else {
                this.dataEngineer = engineer
            }

            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                const url = `${process.env.VUE_APP_ROOT_API}/api/engineer-list`

                this.mutateIsLoading()
                const { data } = await axios.get(url, options)
                this.data_engineerbenchrama3 = data

                this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        },
        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split("-")
            return `${year}-${month}-${day}`
        },
        opennewsub(team, maincaseid) {
            this.$swal({
                title: "Open new sub ?",
                text: "",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((opensub) => {
                if (opensub) {
                    if (this.opennewsub1(team, maincaseid)) {
                    }
                } else {
                }
            })
        },
        opennewsub1(team, maincaseid) {
            this.$router.push({
                path: `/Project/${team}/SubCase/${maincaseid}`,
            })
        },

        alertgotowaitingclose(caseID) {
            this.$swal({
                title:
                    "Confirm ZQTM process completed and send case to queue Waiting Close ?",
                text: "",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((gotowaitingclose) => {
                if (gotowaitingclose) {
                    if (this.gotowaitingclose(caseID)) {
                        swal({
                            title: "Send to Waiting Close completed",
                            icon: "success",
                            button: "OK",
                        })
                    }
                } else {
                }
            })
        },
        async gotowaitingclose(caseID) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/zqtm-complete/${caseID}`

            this.mutateIsLoading()
            const { data } = await axios.get(url, options)
            this.mutateIsLoading()
            setTimeout(() => {
                this.$emit("getSummary-click")
                this.$emit("getCase-click", "Waiting ZQTM")
            }, 1000)

            try {
            } catch (error) {
                console.log(error)
            }
        },
        async favCase(caseID, id, favStatus) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/favourite-case/${caseID}`
            // console.log(favStatus, "showdavvvasdqwe")
            try {
                if (favStatus > 0) {
                    const { data } = await axios.delete(`${url}`, options)
                    this.data_case.data[id].fav = null
                } else {
                    const { data } = await axios.post(`${url}`, {}, options)
                    this.data_case.data[id].fav = 1
                }
            } catch (error) {
                console.log(error)
            }
        },

        async change_cus_pickup(maincase_id) {
            this.mutateIsLoading()
            this.dialog = true
            this.maincase_id = maincase_id
            const tk = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }

            await axios
                .get(
                    `${process.env.VUE_APP_ROOT_API}/api/kcp-case/` +
                        maincase_id,
                    tk
                )
                .then((response) => {
                    this.detailcase = response.data
                    if (response.data.subcase != "") {
                        this.active_tab = response.data.subcase - 1
                    } else {
                        this.active_tab = response.data.subcase
                    }

                    this.data_pickup = response.data
                    this.caseid = response.data.caseid
                    this.autolog = response.data.autolog
                    this.autolog2 = response.data.autolog2
                    this.mutateIsLoading()
                })
                .catch((error) => {
                    this.mutateIsLoading()
                    console.log(error)
                })
        },
        doCopyCase: function() {
            navigator.clipboard.writeText(this.text_copy)
            setTimeout(() => {
                this.showTooltip = !this.showTooltip
            }, 500)
            setTimeout(() => {
                this.showTooltip = false
            }, 2000)
        },
        doCopyCase2: function() {
            navigator.clipboard.writeText(this.text_copy2)
            setTimeout(() => {
                this.showTooltip = !this.showTooltip
            }, 500)
            setTimeout(() => {
                this.showTooltip = false
            }, 2000)
        },
        close_pickup() {
            this.data_pickup = []
            this.text_copy = ""
            this.text_copy2 = ""
            this.caseid = 0
            this.maincase_id = 0
            this.autolog = ""
            this.date = null
            this.dialog = false
        },
        close_changestatus() {
            this.data_pickup = []
            this.text_copy = ""
            this.text_copy2 = ""
            this.caseid = 0
            this.maincase_id = 0
            this.autolog = ""
            this.date = null
            this.buttonstatus = ""
            this.reason = ""
            this.dialogchangestatus = false
        },
        get_auto_log(st) {
            if (st === 1) {
                if (this.date === null) {
                    this.text_copy =
                        this.autolog +
                        " for collect the unit /" +
                        localStorage.fullname
                    this.text_copy2 =
                        this.autolog2 + "/ " + localStorage.fullname
                } else {
                    this.form_save.pickup_date = this.date
                    this.text_copy =
                        this.autolog +
                        " will be pick up the unit on " +
                        this.date +
                        " /" +
                        localStorage.fullname
                    this.text_copy2 =
                        this.autolog2 + "/ " + localStorage.fullname
                }
                this.form_save.status = "call"
                this.form_save.auto_log = this.text_copy
                this.form_save.auto_log2 = this.text_copy2
            } else {
                this.text_copy =
                    "Customer K." +
                    this.data_pickup.customer_name +
                    " ID:.... pick up unit on " +
                    this.date_min +
                    " /" +
                    localStorage.fullname
                this.form_save.status = "pickup"
                this.text_copy2 = this.autolog2 + "/ " + localStorage.fullname
            }
        },
        async save_pickup() {
            const tk = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            this.mutateIsLoading()
            // console.log(this.form_save, "hhh");
            await axios
                .post(
                    `${process.env.VUE_APP_ROOT_API}/api/kcp-case/` +
                        this.maincase_id,
                    this.form_save,
                    tk
                )
                .then((response) => {
                    this.mutateIsLoading()
                    this.close_pickup()
                    this.$emit("getCase")
                    this.$emit("getSummary")
                    this.mutatesnackbar()
                    setTimeout(() => {
                        this.mutatesnackbar()
                    }, 3000)
                })
                .catch((error) => {
                    this.mutateIsLoading()
                    console.log(error)
                })
        },
        async change_status(maincase_id) {
            this.mutateIsLoading()
            this.dialogchangestatus = true
            this.maincase_id_changestatus = maincase_id
            const tk = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }

            await axios
                .get(
                    `${process.env.VUE_APP_ROOT_API}/api/kcp-case/` +
                        maincase_id,
                    tk
                )
                .then((response) => {
                    // console.log(response, "yyy");
                    this.data_pickup = response.data
                    this.caseid = response.data.caseid
                    this.autolog = response.data.autolog
                    this.mutateIsLoading()
                })
                .catch((error) => {
                    this.mutateIsLoading()
                    console.log(error)
                })
        },
        doaunit(maincase_id, case_id, subcase_id) {
            this.dialogdoa = true
            this.btnselect = ""
            this.datacaseID = case_id + "-" + subcase_id
            this.maincase_id_doa = maincase_id
            // this.maincase_id_changestatus = maincase_id;
        },
        async save_changestatus() {
            var sent = {
                status: this.buttonstatus,
                statusquotation: this.buttonquotation,
                remark: this.reason,
            }

            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/update-last-status`
            // console.log(item);
            try {
                const { data } = await axios.post(
                    url + "/" + this.maincase_id_changestatus,
                    sent,
                    options
                )
                this.mutatesnackbar()
                // console.log(data, "true");
                setTimeout(() => {
                    this.mutatesnackbar()
                }, 1000)

                this.dialogchangestatus = false

                if (this.buttonstatus === "incomplete") {
                    this.$swal({
                        title: "Open new sub ?",
                        text:
                            "ถ้ายังไม่เปิดซับใหม่ในตอนนี้ สถานะเคสจะเปลี่ยนเป็น incomplete ",
                        icon: "warning",
                        buttons: true,
                        dangerMode: true,
                    }).then((opensub) => {
                        if (opensub) {
                            this.$router.push({
                                path: `/Project/${this.condition.team}/SubCase/${this.maincase_id_changestatus}`,
                            })
                        }
                    })
                } else {
                    this.$emit("getCase")
                    this.$emit("getSummary")
                }
            } catch (error) {
                console.log(error)
            }
        },
        async passtoonsite(
            maincase_id,
            site_province_id,
            site_amphur_id,
            site_address,
            engineer_id,
            branch_id,
            remark
        ) {
            this.data_onsite.site_address = site_address
            this.data_onsite.maincase_id = maincase_id
            this.data_onsite.engineer = engineer_id
            this.data_onsite.branch_id = branch_id
            this.data_onsite.remark = remark

            await this.getSchedule()
            this.dialogonsite = true
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            // const url = `${process.env.VUE_APP_ROOT_API}/api/svc-zone-ce/${site_province_id}/${site_amphur_id}`;
            const url = `${process.env.VUE_APP_ROOT_API}/api/get-zone-ce/${site_province_id}`
            try {
                const { data } = await axios.get(`${url}`, options)
                this.svc = data
                this.getEngineer(this.data_onsite.branch_id)
            } catch (error) {
                console.log(error)
            }
        },
        getEngineer(branch_id) {
            this.svc.map((each) => {
                if (each.branch_id == branch_id) {
                    this.engineer = ["ZONE", ...each.engineer]
                }
            })
        },
        async savesendtobkk(maincase_id) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/receive-bkk/${maincase_id}`
            try {
                const { data, status } = await axios.post(`${url}`, [], options)
                if (status == 200) {
                    this.$emit("getCase")
                    this.$emit("getSummary")
                } else {
                    alert("error pls check")
                }
            } catch (error) {}
        },
        savequotation(maincase_id, params, subcase_id) {
            this.$swal({
                title: "Confirm Quotation " + params + " ?",
                text: "",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((del) => {
                if (del) {
                    this.save_quotation1(maincase_id, params, subcase_id)
                }
            })
        },
        async save_quotation1(maincase_id, params, subcase_id) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/update-quotation-status/${maincase_id}/${params}`
            try {
                const { data } = await axios.post(`${url}`, [], options)

                if (data.status == "newsub") {
                    this.$router.push(
                        `/Project/${this.condition.team}/SubCase/${maincase_id}`
                    )
                } else if (data.status == "editsub") {
                    this.$router.push(
                        `/Project/${this.condition.team}/EditCase/${maincase_id}/${subcase_id}`
                    )
                } else {
                    this.$emit("getCase")
                    this.$emit("getSummary")
                }
            } catch (error) {
                console.log(error)
            }
        },
        confirmpickup(maincase_id, status) {
            this.pick_up.maincase_id = maincase_id
            this.pick_up.status =
                status == "Pickup Unit"
                    ? "เปิด sub เบิก Part เพิ่ม"
                    : "ไม่สามารถซ่อมได้ ให้ลูกค้าใช้เครื่อง Same ได้เลย"
            this.pick_up.showvalue =
                status == "Pickup Unit" ? "addpart" : "same"
            this.dialogconfirm = true
        },
        async save_confirm() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url =
                this.pick_up.value == "sendcustomer" ||
                this.pick_up.value == "addpart"
                    ? `${process.env.VUE_APP_ROOT_API}/api/return-to-customer/${this.pick_up.maincase_id}`
                    : `${process.env.VUE_APP_ROOT_API}/api/use-same-item/${this.pick_up.maincase_id}`
            try {
                const { data, status } = await axios.post(
                    `${url}`,
                    { status: this.pick_up.value, remark: this.pick_up.remark },
                    options
                )
                if (
                    status == 200 &&
                    (this.pick_up.value == "sendcustomer" ||
                        this.pick_up.value == "addpart")
                ) {
                    this.$router.push(
                        `/Project/${this.condition.team}/SubCase/${this.pick_up.maincase_id}`
                    )
                } else if (status == 200 && this.pick_up.value == "same") {
                    this.$emit("getCase")
                    this.$emit("getSummary")
                } else {
                    alert("error pls check")
                }
            } catch (error) {}
        },
        async getSchedule() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/schedule-time`
            try {
                const { data } = await axios.get(url)
                this.schedule = data
            } catch (error) {
                console.log(error)
            }
        },
        async saveonsite() {
            if (this.data_onsite.engineer == "ZONE") {
                this.data_onsite.dateonsite = ""
            }
            this.mutateIsLoading()
            let tk = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            await axios
                .post(
                    `${process.env.VUE_APP_ROOT_API}/api/pass-to-onsite/` +
                        this.data_onsite.maincase_id,
                    this.data_onsite,
                    tk
                )
                .then((response) => {
                    this.mutateIsLoading()
                    this.$emit("getCase")
                    this.$emit("getSummary")
                    this.dialogonsite = false
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        logchange() {
            this.form_save.auto_log = this.text_copy
        },
        logchange2() {
            this.form_save.auto_log2 = this.text_copy2
        },
    },
    data() {
        return {
            active_tab: 0,
            detailcase: [],
            dataLocationStatus: "",
            search: "",

            remark_status_doa: "",
            maincase_id_doa: "",
            btnselect: "",
            datacaseID: "",
            dataMaincase: "",
            dataEngineer: "",
            dataLocation: "",
            dataType: "",
            data_engineerbenchrama3: [],
            typelocation: ["Pending"],
            datatypeLocation: [],
            EngineerR: [(v) => !!v || "Engineer is required"],
            LocationR: [(v) => !!v || "Location is required"],
            TypeR: [(v) => !!v || "Type is required"],
            validassign: false,
            validdoa: false,
            dialogassign: false,
            team_name: localStorage.team_name,
            reasonR: [(v) => !!v || "Reason is required"],
            remarkR: [(v) => !!v || "Remark is required"],
            valid: false,
            reason: "",
            buttonstatus: "",
            buttonquotation: "",
            maincase_id_changestatus: 0,
            dialogchangestatus: false,
            dialogdoa: false,
            dialog: false,
            showTooltip: false,
            text_copy: "",
            text_copy2: "",
            data_pickup: [],
            caseid: 0,
            maincase_id: 0,
            status_log: null,
            date: null,
            datemenu: false,
            datemenu1: false,
            autolog: "",
            autolog2: "",
            form_save: {
                status: "",
                pickup_date: null,
                auto_log: "",
                auto_log2: "",
            },
            text: "Success, Your work has been saved",
            date_min: new Date().toISOString().substr(0, 10),
            pick_up: {
                maincase_id: "",
                status: "",
                value: "",
                showvalue: "",
                remark: "",
            },
            dialogconfirm: false,
            dialogonsite: false,
            svc: [],
            engineer: [],
            schedule: [],
            data_onsite: {
                maincase_id: "",
                branchid: "",
                engineer: "",
                dateonsite: "",
                timeonsite: "",
                site_address: "",
                remark: "",
            },
            datenew: new Date().toISOString().substr(0, 10),
            today: new Date().toISOString().substr(0, 10),
            booking_by: localStorage.fullname,
        }
    },
    watch: {
        dataLocation(val) {
            if (val != null && val != undefined) {
                this.$nextTick(() => this.dataLocation.pop())
            }
        },
    },
}
</script>
